export default __webpack_public_path__ + "static/media/avatarA3.0f0d51e5.png";